
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { Mission } from '@/components/mission-hub/Mission';
import { MissionHubHeader } from '@/components/mission-hub/MissionHubHeader';
import { MissionHubTabs, TabOption } from '@/components/mission-hub/MissionHubTabs';
import { usePoints } from '@/hooks/missionhub/points';
import { useTwitter } from '@/hooks/missionhub/twitter';
import { sortByKey } from '@/utils/common';
import { getMissionHubTasks, TaskCategories } from '@/utils/http/get-mission-tasks';
import classNames from 'classnames';
import { InferGetServerSidePropsType } from 'next';
import Head from 'next/head';
import { useMemo, useState } from 'react';
import { FiRotateCw } from 'react-icons/fi';
import WalletConnection from '@/components/wallet/WalletConnection';

export type TaskStatus = 'available' | 'ended';
export type TaskType = TaskStatus | TaskCategories;

const tabs: TabOption<TaskType>[] = [
    { _id: 'available', label: 'Active Missions' },
    { _id: 'challenge', label: 'Challenges' },
    { _id: 'twitter', label: 'Twitter Missions' },
    { _id: 'qa', label: 'QA Missions' },
    { _id: 'ended', label: 'Ended Missions' },
];

const MissionHub = ({ tasks }: InferGetServerSidePropsType<typeof getStaticProps>) => {
    const { isLoading, refreshPoints, signup } = usePoints();
    useTwitter();
    const [currentTab, setCurrentTab] = useState<TaskType>('available');
    const filteredTasks = useMemo(() => {
        let _tasks;
        switch (currentTab) {
            case 'available':
                _tasks = tasks.filter((x) => !x.isEnded);
                break;
            case 'ended':
                _tasks = tasks.filter((x) => x.isEnded);
                break;
            default:
                _tasks = tasks.filter((x) => x.tags?.includes(currentTab));
                break;
        }

        // Filter tasks
        _tasks = sortByKey(_tasks, 'title', false);
        const active = _tasks.filter((x) => !x.isEnded);
        const ended = _tasks.filter((x) => x.isEnded);
        return [...active, ...ended];
    }, [currentTab]);

    const TabAction = () => {
        return (
            <div className="items-center hidden space-x-2 md:flex">
                <button
                    onClick={refreshPoints}
                    aria-label="Refresh"
                    className="items-center hidden p-2 space-x-2 rounded-lg md:flex hover:bg-purple-90 hover:text-purple-50"
                >
                    <FiRotateCw
                        className={classNames({
                            'animate-spin': isLoading,
                        })}
                    />
                    <span className="text-white t__button--u2">Refresh</span>
                </button>
            </div>
        );
    };

    return (
        <>
            <Head>
                <title>ClayStack | Mission Hub</title>
            </Head>
            <WalletConnection />
            <div className="absolute top-8 right-0 2xl:right-[5%] z-[-1] w-full h-full">
                <div className="gr--blue">
                    <div className="gr--red"></div>
                </div>
            </div>
            <div className="container px-4 mx-auto">
                <MissionHubHeader
                    className="mt-12 mb-8"
                    title="Missions"
                    caption="Complete tasks each week, earn points and experience Liquid Staking"
                />
                <MissionHubTabs<TaskType>
                    tabs={tabs}
                    actionEl={<TabAction />}
                    onTabSelect={(id: TaskType) => setCurrentTab(id)}
                />
                {filteredTasks && (
                    <div className="md:mr-2">
                        <div className="grid grid-cols-1 gap-6 pt-8 pb-12 point-system__content md:grid-cols-3 xl:grid-cols-4">
                            {filteredTasks.map((mission, index) => (
                                <Mission key={index} mission={mission} signup={signup} refreshPoints={refreshPoints} />
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

 const _getStaticProps = async () => {
    const tasks = await getMissionHubTasks();
    return {
        props: {
            tasks,
            refreshTimestamp: Date.now(),
            revalidate: 60 * 60, //1 hour,
        },
    };
};

export default MissionHub;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/mission-hub',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  